import Support from "../assets/support.gif"
import Savings from "../assets/savings.gif"
import Consult from "../assets/consult.gif"
import Hastle from "../assets/hastle.gif"
import Performance from "../assets/performance.gif"
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import { useEffect } from "react"
import AOS from 'aos';
import 'aos/dist/aos.css';

const CommercialIndustrial = () => {
    useEffect(() => {
        AOS.init();    
    }, []);
    return (
        <div>
            <Helmet>
                <title>Rave Energy | Commercial and Industrial</title>
                <meta name="keywords" content="HTML,CSS,JavaScript" />
                <meta
                    name="description"
                    content="Our technology services."
                />
            </Helmet>
            <main style={{ color : `#2C3E50` }}>
                <div className="h-56 sm:h-40 md:h-40 lg:h-40 xl:h-40" style={{ background: `#00102f`}}>
                    <h1 className="font-bold text-center tracking-tighter text-4xl md:text-4xl lg:text-5xl pt-24 sm:pt-24 md:pt-24 lg:pt-12 xl:pt-12 text-white">Commercial and Industrial</h1>
                </div>
                <div className="flex flex-col items-center sm:px-4 md:px-0 lg:px-4 mt-8">
                    <h1 className="font-medium tracking-tighter sm:text-6xl text-4xl mt-0 sm:mt-6 md:mt-6 lg:mt-6 xl:mt-6 text-center">Long Term <span className="text-red-500"> Energy </span> Solutions</h1>
                    <p className="sm:text-justify text-center font-light text-xl max-w-3xl mt-4 px-4 md:px-0 lg:px-0 mt-6">When it comes to calculating long-term expenditures, few industries are as complex as commercial and industrial. Between the ever-changing costs of raw materials, commodities, and the energy needed to run your business, it’s difficult to navigate – much less secure long-term budget certainty– in a way that benefits your bottom line across such volatile markets.</p>
                    <p className="sm:text-justify text-center font-light text-xl max-w-3xl mt-4 px-4 md:px-0 lg:px-0">With our expertise, your organization gains access to a broad array of fully customizable energy solutions, including a Reverse Auction. These services are designed to lower your costs for electricity and natural gas, meet your long-term energy budget, and streamline the procurement process to make it simple and more transparent.</p>
                    <p className="sm:text-justify text-center font-light text-xl max-w-3xl mt-4 px-4 md:px-0 lg:px-0">As your energy partner, we offer your organization the flexibility to make educated energy decisions – along with the tools, resources, and expert insights to meet your sustainability and efficiency objectives.</p>
                </div>
                <div>
                    <h1 className="font-medium tracking-tighter text-center sm:text-6xl text-4xl mt-6">What <span className="text-red-500"> We </span> Offer</h1>
                    <div data-aos-ease="ease" data-aos-duration="400" data-aos="fade-up" className="flex flex-col items-center mt-6">
                        <div className="flex flex-col md:flex-row lg:flex-row xl:flex-row">
                            <div className="flex flex-col items-center m-0 md:mr-8 lg:mr-8 xl:mr-8">
                                <img className="m-2 w-44 mx-auto antialiased" src={Support} alt="Demand Response" height="200" width="250" />
                                <h1 className="font-medium text-center text-2xl tracking-tighter">Ongoing Support</h1>
                            </div>
                            <div className="flex flex-col items-center m-0 md:mx-8 lg:mx-8 xl:mx-8">
                                <img className="m-2 w-44 mx-auto" src={Savings} alt="Demand Response" height="200" width="250" />
                                <h1 className="font-medium text-center text-2xl tracking-tighter">Complimentary Savings Analysis</h1>
                            </div>
                            <div className="flex flex-col items-center m-0 md:ml-8 lg:ml-8 xl:ml-8">
                                <img className="m-2 w-44 mx-auto" src={Consult} alt="Demand Response" height="200" width="250" />
                                <h1 className="font-medium text-center text-2xl tracking-tighter">Complimentary Consultation</h1>
                            </div>
                        </div>
                        <div className="flex flex-col md:flex-row lg:flex-row xl:flex-row mt-8">
                            <div className="flex flex-col items-center m-0 md:mr-8 lg:mr-8 xl:mr-8">
                                <img className="m-2 w-44 mx-auto" src={Hastle} alt="Demand Response" height="200" width="250" />
                                <h1 className="font-medium text-center text-2xl tracking-tighter">Commitment and Hastle Free</h1>
                            </div>
                            <div className="flex flex-col items-center m-0 md:ml-8 lg:ml-8 xl:ml-8">
                                <img className="m-2 w-44 mx-auto" src={Performance} alt="Demand Response" height="200" width="250" />
                                <h1 className="font-medium text-center text-2xl tracking-tighter">Performance Driven Results</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center py-8">
                    <h1 className="font-medium tracking-tighter text-center sm:text-6xl text-4xl mt-0 sm:mt-6 md:mt-6 lg:mt-6 xl:mt-6">Learn <span className="text-red-500"> More!</span></h1>
                    <Link className="px-8 py-3 bg-red-500 rounded mt-8 text-white text-xl hover:shadow-md transition duration-500" to="/contact">Contact us</Link>
                </div>
            </main>
        </div>
    );
}
 
export default CommercialIndustrial;